module.exports = __webpack_public_path__ + "img/icon-pin.d3e6ba20.svg";